<template>
    <Card :bordered="false" class="border-radius-0">
        <Form :ref="e => (refs.form = e)" layout="horizontal">
            <TemplateBuilder :rowProp="data.rowProp" :useForm="data.useForm" :fields="data.fields" :skeleton="isLoading"></TemplateBuilder>
        </Form>
    </Card>
</template>

<script>
import { Card, Form } from "ant-design-vue";
import { computed, defineAsyncComponent, defineComponent, onBeforeUnmount, reactive } from "vue";
import { useRoute } from "vue-router";
import { state as stateApp } from "../../../../../app.logic";
import websocket from "../../../../../utils/websocket";
import { createFormTitle, initForm, initState, isLoading, onClickModalOk, onWebsocketConnect } from "./tab1.logic";

export default defineComponent({
    components: {
        Card,
        Form,
        TemplateBuilder: defineAsyncComponent(() => import("../../../../../components/input/template-builder/TemplateBuilder"))
    },
    props: {
        menuContext: { default: () => stateApp.menuContext },
        routerPrefix: { default: "company-mgt-tab-1-1" },
        viewOnly: { default: false },
        form: {},
        setAppPageHeader: { default: true },
        visibleChangeLog: { default: true }
    },
    setup(props) {
        const route = useRoute();
        const id = props.form ? props.form.id : route.params?.id;
        const companyId = route.params?.companyId;
        const state = reactive(initState({ props, companyId }));
        const data = reactive({ rowProp: { gutter: 24 }, id, fieldLogs: [], linkIdCard: {}, linkageReceive001: false, linkageReceive009: false });
        const refs = reactive({ form: null });
        initForm({ props, data, refs, state, companyId });
        const callOnClickModalOk = () => onClickModalOk({ data, refs });
        const title = computed(() => createFormTitle({ data }));
        state.websocketId = websocket.connect(() => onWebsocketConnect({ props, data, refs, state, companyId }));
        onBeforeUnmount(() => {
            state.websocketSubscribes.forEach(d => websocket.unsubscribe(d.path, d.id));
            state.websocketSubscribes.splice(0, state.websocketSubscribes.length);
        });
        return {
            props,
            data,
            refs,
            state,
            title,
            isLoading,
            callOnClickModalOk
        };
    }
});
</script>
